import React from 'react';
import type {
  CompareEntitiesContextProps,
  CompareEntitiesFormsProps,
} from '../types';
import {
  CompareEntitiesContext,
  useCompareEntitiesContextProviderValue,
} from '../context/CompareEntitiesContext';
import {CompareEntitiesCore} from './CompareEntitiesCore';

export const CompareEntities: React.FC<
  CompareEntitiesContextProps & CompareEntitiesFormsProps
> = ({formConfiguration, sourceHeader, targetHeader, ...contextProps}) => {
  const provider = useCompareEntitiesContextProviderValue(contextProps);

  return (
    <CompareEntitiesContext value={provider}>
      <CompareEntitiesCore
        formConfiguration={formConfiguration}
        targetHeader={targetHeader}
        sourceHeader={sourceHeader}
      />
    </CompareEntitiesContext>
  );
};
